/*
 * Copyright © 2025 EC Studios Ltd.
 * All rights reserved
 */

import React from 'react';
import {Badge, IconButton, Tooltip} from '@mui/material';
import FeedbackIcon from '@mui/icons-material/Feedback';
import {useFeedback} from '../../status/StatusContext';
import {useHasPermission} from '../../permission/PermissionUtil';
import {useNavigate} from 'react-router-dom';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function FeedbackButton() {

    const navigate = useNavigate();

    const openReports = () => {
        navigate("/player/feedback");
    };

    const hasViewFeedbackPermission = useHasPermission("Feedback:View");
    const feedbackCount = useFeedback();

    if (!hasViewFeedbackPermission) {
        return null;
    }

    return (
        <IconButton
            size="large"
            type='button'
            onClick={openReports}
            color="inherit"
            style={squareHighlightStyle}
        >
            <Badge badgeContent={feedbackCount} color="info">
                <Tooltip title='Unseen Feedback'>
                    <FeedbackIcon/>
                </Tooltip>
            </Badge>
        </IconButton>
    );
}
